module.exports = __webpack_public_path__ + "media/day/227-d9af1c81.svg";